import { IResponseFormatWithToken } from "@/interfaces/IHelper";
import { IProfile } from "@/interfaces/IProfile";

export enum IConnectSocial {
  DISCORD = "discord",
  SOCIAL_DISCORD = "social-discord",
  SOCIAL_GOOGLE = "social-google",
}
export interface IAuthData extends Pick<IProfile, "email" | "username"> {
  password: string;
}

export type ICookie = Pick<IResponseRefreshToken, "refresh_token" | "token"> &
  Pick<IProfile, "created_from">;

export interface IRegisterData
  extends Pick<IAuthData, "email" | "password" | "username"> {
  confirmPassword: string;
  code: string;
  otp_number: string;
}

export interface IToken {
  // jwtToken: string;
  // refreshToken: string;
  expires_in: number;
  token: string;
}
export interface IResetPassword
  extends Pick<IRegisterData, "email" | "password" | "confirmPassword">,
    Pick<IToken, "token"> {}

export interface IRefreshToken extends Pick<IToken, "token"> {
  profile: string;
  expires: string;
  created: string;
  _id: string;
  __v: number;
  token_login: string;
}

export interface IResponseRefreshToken
  extends Omit<IResponseFormatWithToken, "refresh_expire" | "refresh_token"> {
  refresh_token: string;
}

export interface IAuthGetCode {
  email: string;
  recaptcha: string;
}

export interface IRefreshToken {
  profile: string;
  token: string;
  expires: string;
  created: string;
  _id: string;
  token_login: string;
}

export interface ILoginWithProvider {
  email: string;
  provider: string;
  providerUUID: string;
}

export interface IResponseDiscord {
  id: string;
  username: string;
  avatar: string;
  discriminator: string;
  public_flags: number;
  flags: number;
  banner: null;
  accent_color: null;
  global_name: string;
  avatar_decoration_data: null;
  banner_color: null;
  clan: null;
  primary_guild: null;
  mfa_enabled: boolean;
  locale: string;
  premium_type: number;
  email: string;
  verified: boolean;
}
export interface IResponseSignInDiscord
  extends Omit<IResponseFormatWithToken, "refresh_token"> {
  refresh_token: string;
}
